/**
 *  common.js
 */

/**
 * global; ユーザーエージェント
 * @type {String}
 */
window.userAgent = window.navigator.userAgent.toLowerCase()
/**
 * global; APPバージョン
 * @type {String}
 */
window.appVersion = window.navigator.appVersion.toLowerCase()

/**
 * global; ページスクロールの対象要素
 * @type {String}
 */
window.g_scrollBody = (userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident') > -1 || userAgent.indexOf('firefox') > -1 ) ? 'html' : 'body'
/*　chrome61以上　*/
if (userAgent.indexOf('chrome') > -1 && userAgent.indexOf('edge') == -1) {
  let chromeVersion = window.appVersion.match(/chrome\/.* /)
  chromeVersion = chromeVersion[0].replace('chrome/', '').replace(' ', '')
  chromeVersion = Number(chromeVersion.split('.')[0])
  if (chromeVersion >= 61) {
    window.g_scrollBody = 'html'
  }
}

if (userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident')) {
  window.isIE = true
}

/**
 * - テンプレートの {{キー}} にアイテムの値を置換
 * - テンプレートの {%if:キー%}{%endif%}で囲まれた箇所を
 *     値が true のときは表示、false のときは非表示
 * @param  {String} template アイテムのテンプレート
 * @param  {Object} item     アイテムのデータ
 * @return {String}          実際の値が入ったアイテムの文字列
 */
window.setItemValues = (template, item) => {
  for(let key in item) {
    template = template.replace(new RegExp("\\{\\{" + key + "\\}\\}", "g"), item[key])
    template = template.replace(
      new RegExp("\\{%if:" + key + "%\\}.+?\\{%endif%\\}", "g"),
      match => item[key] ? match.replace('\{%if:' + key + '%\}', '').replace('{%endif%}', '') : ''
    )
  }
  template = template.replace(new RegExp("\\{\\{.*?\\}\\}", "g"), "")
  return template
}

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
(() => {
  let lastTime = 0;
  const vendors = ['ms', 'moz', 'webkit', 'o'];
  for(let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame']
    window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                                || window[vendors[x]+'CancelRequestAnimationFrame']
  }

  if (!window.requestAnimationFrame)
    window.requestAnimationFrame = (callback, element) => {
      const currTime = new Date().getTime()
      const timeToCall = Math.max(0, 16 - (currTime - lastTime));
      const id = window.setTimeout(() => {
        callback(currTime + timeToCall)
      }, timeToCall)
      lastTime = currTime + timeToCall
      return id
    };

  if (!window.cancelAnimationFrame)
    window.cancelAnimationFrame = id => {
      clearTimeout(id)
    }
})()

/**
 * イージング関数
 * @type { {key: Function} }
 */
const Ease = {
  easeInOut: t => t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1
}
/**
 * スムーススクロール
 * @param {String} href スムーススクロール対象のIDセレクタもしくはURL
 * @param {Boolean} isForce スムーススクロールを強制的に実行
 * @param {Number} duration スクロールアニメーションのスピード(単位: ms)
 */
window.smoothScroll = (href, isForce, duration) => {
  duration = typeof duration == 'undefined' ? 1000 : duration;
  let hrefSplitByHash = href.split('#');
  const targetElementId = hrefSplitByHash.pop();
  const hrefUrlWithoutHash = hrefSplitByHash[0];
  const currentUrlWithoutHash = String(location.href).split('#')[0];
  const margin = window.innerWidth > 768 ? 0 : 60;
  if (hrefUrlWithoutHash == currentUrlWithoutHash || isForce){
    const currentPostion = document.documentElement.scrollTop || document.body.scrollTop;
    const targetElement = document.getElementById(targetElementId);
    if (targetElement) {
      let targetPosition = window.pageYOffset + targetElement.getBoundingClientRect().top - margin;
      const startTime = performance.now();
      const loop = nowTime => {
        const time = nowTime - startTime;
        const normalizedTime = time / duration;
        targetPosition = window.pageYOffset + targetElement.getBoundingClientRect().top - margin;
        if (normalizedTime < 1) {
          window.scrollTo(0, currentPostion + ((targetPosition - currentPostion) * Ease.easeInOut(normalizedTime)));
          requestAnimationFrame(loop);
        } else {
          window.scrollTo(0, targetPosition);
        }
      }
      requestAnimationFrame(loop);
    }
  } else {
    location.href = href;
  }
}

import header from './modules/header'
import checkDevice from './modules/checkDevice'
import animation from './modules/animation'
import component from './modules/component'
import breadcrumbList from './modules/breadcrumbList'
import jiyukenkyu from './modules/jiyukenkyu'

(() => {

  document.createElement('main')

  header($)
  checkDevice($)
  animation($)
  component($)
  breadcrumbList($)
  jiyukenkyu($)

})();
